import React, { FC, useEffect, useState } from 'react'
import { withRouter, useHistory } from 'react-router';
import LoopFront from 'loop-front';
import Config from 'Resources/Config';
import { useDispatch } from 'react-redux';
import { TDispatch } from 'Typings/Global';
import { OApp } from 'Models/App';
import CircularLoader from 'Components/Loader/CircularLoader';
import AppNavigation from 'Route/AppNavigation';
import { Box } from '@material-ui/core';

const RootLayout: FC = () => {
    const [splash, setSplash] = useState(true);

    const dispatch = useDispatch<TDispatch>();
    const history = useHistory();

    const appInit = async () => {
        const location = window.location.pathname;
        const newLocation = (!location || location === '/') ? '/dashboard' : location;
        const res = await dispatch(OApp.init()).catch(error => {
            history.push('/')
            setSplash(false);
        });
        if (!res) {
            history.push('/')
            setSplash(false);
        }
        else {
            res && history.push(newLocation);
            setSplash(false);
        }
    }

    useEffect(() => {
        LoopFront.init(Config.API_BASE_URL, { log: false });
        appInit();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        splash
            ?
            <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'} >
                <CircularLoader />
            </Box>
            :
            <AppNavigation />
    );

}


export default withRouter(RootLayout);